import API, { IRI, defaultHeaders } from '@/api';

const fetchPut = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.exam}${payload.id}/`, {
    headers,
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

export default fetchPut;
